"use strict";
import { atom } from "jotai";
export const privateSwapInProgressAtom = atom(false);
